export default __webpack_public_path__ + "static/media/switzerland-flag.e587bca3.png";